import { AppConfigService } from "./core/app-config/app-config.service";

export function appInitializer(appService: AppConfigService) {
  return () => appService.load();
}
